import React, { useState } from "react";
import "./Tooltip.css";

export const Tooltip = ({ text, children }) => {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <div className="tooltip-container">
            <div
                className="tooltip-trigger"
                onMouseEnter={() => setIsVisible(true)}
                onMouseLeave={() => setIsVisible(false)}
            >
                {children}
            </div>
            {isVisible && (
                <div className="tooltip-content">
                    {text}
                </div>
            )}
        </div>
    );
};
